import { render } from "./BalanceCard.vue?vue&type=template&id=56c75e3c&scoped=true"
import script from "./BalanceCard.vue?vue&type=script&lang=js"
export * from "./BalanceCard.vue?vue&type=script&lang=js"

import "./BalanceCard.vue?vue&type=style&index=0&id=56c75e3c&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c75e3c"]])

export default __exports__